/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
// import { Card } from 'src/Common/ui/card'
import { Tabs, TabsList, TabsTrigger } from 'src/Common/ui/tabs'
import { useForm } from 'react-hook-form'
import { cn, featValid, getOrdinalSuffix, roleColor } from 'src/lib/utils'
import { useGovernanceStore } from 'src/Containers/Onboarding/Store/GovernanceStore'
import { compLianceControls, complianceData } from 'src/Entities/Governance'
import { useTranslation } from 'react-i18next'
import EditPencilIcon from 'src/Common/Icon/EditPencilIcon'
import * as RoutePath from 'src/Entities/RoutePath'
import UserBinaryQuestionTable from './Components/UserBinaryQuestionTable'
import UserFormsQuestionTable from './Components/UserFormsQuestionTable'
import UserThresholdLimitQuestions from './Components/UserThresholdLimitQuestions'
import UserChecklistQuestions from './Components/UserChecklistQuestions'
import { useCompStore } from 'src/Components/Governance/Store/ComplianceStore'
import ComplianceDrawer from './Components/ComplianceDrawer'
import { monthNames } from 'src/Entities/ComplianceListViewEntity'
import { Button } from 'src/Common/ui/button'
import TimelineDialog from 'src/Components/Governance/TimelineDialog'
import { UPDATE_COMPLIANCE } from 'src/Entities/Features'
import { ACC_RACID, BINARY_CONTROL_ID, CHECKLIST_CONTROL_ID, FORM_CONTROL_ID, RESP_RACID } from 'src/Entities/ComplianceTypes'
import { Card, Tooltip } from '@mui/material'
import ComplianceCommentsDrawer from 'src/Components/Governance/Components/ComplianceCommentsDrawer'
import ApproveDialog from './Components/ApproveDialog'
import ViewRejectComments from './Components/ViewRejectComments'
import { STATUS_ENUMS } from 'src/Entities/StatusEnums'
import Loading from 'src/Common/ui/Loading'
import { VerticalTimelineContainer } from '../Governance/VerticalTimeline/VerticalTimelineContainer'
import { useSettingsStore } from 'src/Containers/SettingsContainer/Store/Store'

// import Loading from 'src/Common/ui/Loading'

function ViewComplianceUser() {
    const { getConfigurationBasedOrganization, configurationData } = useSettingsStore()

    const [data, setdata] = useState(null)
    const { getOrgRegulation, getOrgRegulationData } = useGovernanceStore()
    const { control, formState: { errors } } = useForm()
    const [moreDetails, setMoreDetails] = useState(false)
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const bodyType = queryParams.get('bodyType')
    const view = queryParams.get('view')
    // const regulation = +queryParams.get('regulation')
    const complainceId = +queryParams.get('complianceId')
    // Create a new Date object
    const {
        getCompFor,
        getCompCategory,
        getCompSubCategory,
        getCompFrequency,
        ViewAnswerComplianceById,
        getModifiedDueDate,
        modifiedDueDate,
        compById,
        complianceCategory,
        complianceSubCategory,
        compFrequency
    } = useCompStore()
    // const navigate = useNavigate()
    const { t } = useTranslation()
    const complianceFor = useCompStore((state) => state.complianceFor)
    const { createUserCompliance, createApproveCompliance, getComplianceTimeline } = useCompStore()
    const complianceTimelineData = useCompStore((state) => state.complianceTimelineData)
    const [compCategoryOptions, setCompCategoryOptions] = useState([])
    const [compSubCategoryOptions, setCompSubCategoryOptions] = useState([])
    const [compForOptions, setCompForOptions] = useState([])
    const [frequencies, setFrequencies] = useState([])
    const [editState, setEditState] = useState({ right: false })
    const [editData, setEditData] = useState(null)
    const [isAccontableAvail, setAccountableAvail] = useState(1) //  1 means accountable is there, 0 means accounatble isnt avail to approve
    const orgId = localStorage.getItem('orgId')
    const [loading, setLoading] = useState(false)

    const apiCall = async () => {
        const dateString = queryParams.get('dueBy')
        setBinaryArray([])
        setLoading(true)
        await ViewAnswerComplianceById(complainceId, dateString, userId)
        setLoading(false)
        await getConfigurationBasedOrganization(orgId)
        await getOrgRegulation(orgId, userId, 3)
        await getCompFor()
        await getCompCategory()
        await getCompSubCategory()
        await getCompFrequency()
    }
    const [sepLoading, setSepLoading] = useState(false)
    const viewCompById = () => {
        setSepLoading(true)
        const dateString = queryParams.get('dueBy')
        ViewAnswerComplianceById(complainceId, dateString, userId).then(() => {
            setSepLoading(false)
        })
    }
    useEffect(() => {
        (async function () {
            await apiCall()
        })()
    }
        , [])

    useEffect(() => {
        const data = configurationData?.find(element => element.kindId === 2)
        setAccountableAvail(data?.values)
    }, [configurationData])
    useEffect(() => {
        if (modifiedDueDate) {
            if (Object.keys(modifiedDueDate)?.length > 0) {
                setEditData({
                    // dueBy: modifiedDueDate?.dueDate?.[modifiedDueDate?.dueDate?.length - 1],
                    // remarks: modifiedDueDate?.remarks?.[modifiedDueDate?.remarks?.length - 1],
                    dueBy: modifiedDueDate?.dueDate?.[0],
                    remarks: modifiedDueDate?.remarks?.[0],
                    attachments: modifiedDueDate?.attachments
                })
            }
        }
    }, [modifiedDueDate])
    useEffect(() => {
        if (complianceFor?.length > 0) {
            setCompForOptions(complianceFor.map((item) => {
                return {
                    value: item.id, label: item.name
                }
            }))
        }
    }, [complianceFor])
    useEffect(() => {
        if (complianceCategory?.length > 0) {
            setCompCategoryOptions(complianceCategory.map((item) => {
                return {
                    value: item.id, label: item.name
                }
            }))
        }
    }, [complianceCategory])
    useEffect(() => {
        if (complianceSubCategory?.length > 0) {
            setCompSubCategoryOptions(complianceSubCategory.map((item) => {
                return {
                    value: item.id, label: item.name
                }
            }))
        }
    }, [complianceSubCategory])
    useEffect(() => {
        if (compFrequency?.length > 0) {
            setFrequencies(compFrequency?.map((item) => {
                return {
                    value: item.id, label: item.name
                }
            }))
        }
    }, [compFrequency])
    const userId = localStorage.getItem('userId')
    useEffect(() => {
        if (compById?.organizationId) {
            setdata(null)
            const actTab = +queryParams.get('activeTab')
            setdata(compById)
            setComments(compById?.rejectedComments)
            setActiveTab(actTab)
            setviewTab(compById.complainceControlIndex[actTab]?.controlId)
        }
    }, [compById])
    useEffect(() => {
        if (data?.organizationId) {
            surveyValidate()
            // setBinaryArray(data?.binaryQuestions)
        }
    }, [data])
    const routePath = '/GRC' + RoutePath.COMPLIANCE.MANAGE_COMPLIANCE
    const [activeTab, setActiveTab] = useState(0)
    const [viewTab, setviewTab] = useState()
    const raci = {
        Responsible: [],
        Accountable: [],
        Consulted: [],
        Informed: []
    }
    const dateConvert = (value) => {
        const date = new Date(value)
        return date ? `${monthNames[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}` : 'NA'
    }
    const monthConvert = (value) => {
        const date = new Date(value)
        return date ? `${monthNames[date.getMonth()]}, ${date.getFullYear()}` : 'NA'
    }
    const onTabValueChange = value => {
        setActiveTab(value)
        setControls(prevstate => {
            const finaldata = prevstate.map(item => {
                if (item.controlId === +value) {
                    item.isChecked = true
                } else {
                    item.isChecked = false
                }
                return item
            })
            return finaldata
        })
        queryParams.set('activeTab', value)
        navigate(`?${queryParams.toString()}`)
    }
    const [controls, setControls] = useState(compLianceControls)
    const [binaryArray, setBinaryArray] = useState([])
    function dataFind(search, value) {
        const data = search.find(item => item.value === value)
        return data?.label
    }
    const navigate = useNavigate()
    const handleTab = (type) => {
        switch (type) {
            case 'inc':
                if (activeTab < 3) {
                    setActiveTab(activeTab + 1)
                    queryParams.set('activeTab', activeTab + 1)
                    navigate(`?${queryParams.toString()}`)
                }
                break
            case 'dec':
                if (activeTab > 0) {
                    setActiveTab(activeTab - 1)
                    queryParams.set('activeTab', activeTab - 1)
                    navigate(`?${queryParams.toString()}`)
                }
                break
            default:
                break
        }
    }
    const [submitValid, setSubmitValid] = useState(true)
    const [submittionComplete, setSubmissionComplete] = useState(false)
    const [atleastChecklist, setAtleastChecklist] = useState(false)
    const surveyValidate = (finalData = null, from = null) => {
        const find = data?.complainceControlIndex?.find(ele => +ele.index === +activeTab)
        switch (find?.controlId) {
            case 1:
                {
                    const find = data?.binaryQuestions?.[data?.binaryQuestions?.length - 1]?.answer === '1'
                    if (find) {
                        setSubmitValid(true)
                        setSubmissionComplete(false)
                    } else {
                        const subComp = data?.binaryQuestions?.[data?.binaryQuestions?.length - 1]?.answer === '2'
                        if (subComp) {
                            setSubmissionComplete(true)
                            setSubmitValid(true)
                        } else {
                            setSubmitValid(false)
                        }
                    }
                }
                break
            case 2:
                {
                    const changeData = from === 'draw' ? finalData : data
                    const formsAnswers = changeData.forms.map(item => item.formResponses[0]).every(ele => {
                        return ele?.byWhen !== null && ele?.byWhen !== ''
                    })
                    if (formsAnswers) {
                        setSubmitValid(true)
                    } else {
                        setSubmitValid(false)
                    }
                }
                break
            case 3:
                // const changeData = from === 'draw' ? finalData : data
                // const thresholdLimit = changeData?.thresholdLimits?.map(item => item.thresholdLimitResponses[0]).every(t => {
                //     return t.investedAmount !== null && t.investedAsOn !== null && t.marketValueAmount !== null && t.marketValueAsOn !== null
                // })
                // if (thresholdLimit) {
                //     setSubmitValid(true)
                // } else {
                //     setSubmitValid(false)
                // }
                break
            case 4:
                {
                    const find = data?.checkLIst.every(item => {
                        return item.response
                    })
                    // if (find) {
                    //     setSubmitValid(true)
                    // } else {
                    //     setSubmitValid(false)
                    // }
                    const find2 = data?.checkLIst.some(item => {
                        return item.response
                    })
                    if (find2) {
                        setAtleastChecklist(true)
                    } else {
                        setAtleastChecklist(false)
                    }
                    break
                }
            default:
                break
        }
    }
    useEffect(() => {
        setviewTab(data?.complainceControlIndex[activeTab]?.controlId)
        surveyValidate()
    }, [activeTab])
    const editCompliance = () => {
        setEditState({ right: true })
        setDrawType('dueDateEdit')
        getModifiedDueDate(data.id, data.dueBy)
    }

    const convertDataForPost = () => {
        const finalData = data
        const todayDate = new Date()
        todayDate.setDate(todayDate.getDate)
        const finalWholeData = {
            id: finalData.regulationId,
            orgId: finalData.organizationId,
            loginId: userId,
            complianceId: finalData.id,
            action: finalData.complainceTimeline.action,
            timeline: finalData.complainceTimeline.timeLine,
            period: finalData.complainceTimeline.period,
            frequency: finalData.frequency,
            dueBy: finalData.dueBy,
            cutOff: finalData.cutOff,
            dueFor: finalData.dueFor,
            internalCutoff: 0,
            approvalStatus: 0,
            binaryAnswers: binaryArray.map((item) => {
                if (item.answer) {
                    const binItem = {
                        questionUID: item.questionUID
                    }
                    if (item.answer === '1' || item.answer === '2') {
                        binItem.quesId = null
                        binItem.answer = +item.answer
                    } else {
                        binItem.quesId = item.answer
                        binItem.answer = 0
                    }
                    return binItem
                }
                return null
            }).filter(ele => ele !== null),
            formResponses: finalData.forms > 0
                ? finalData.forms.map((item) => {
                    Object.keys(item.formResponses[0]).length.forEach((ele) => {
                        if (!item.formResponses[0][ele]) {
                            delete item.formResponses[0][ele]
                        }
                    })
                    return item.formResponses[0]
                }).filter(ele => ele !== null)
                : [],
            thresholdLimitResponses: finalData.thresholdLimits.map((item) => {
                const verify = Object.keys(item.thresholdLimitResponses[0]).some((ele) => {
                    return item.thresholdLimitResponses[0][ele]
                })
                if (verify) {
                    return item.thresholdLimitResponses[0]
                }
                return null
            }).filter(ele => ele !== null),
            checkListResponses: finalData.checkLIst.map(item => {
                return {
                    checkListId: item.id,
                    response: item.response,
                    completedDate: item.checkListResponses[0].completedDate
                }
            })
        }
        if (
            (
                ((viewTab === BINARY_CONTROL_ID && +viewTab === +data.complainceControlIndex[data.complainceControlIndex.length - 1].controlId) || finalWholeData.binaryAnswers.find((ele) => ele.answer === 2)) && submitValidCheck(finalWholeData)
            ) || (submitValidCheck(finalWholeData) && submitValid && viewTab !== CHECKLIST_CONTROL_ID)) {
            finalWholeData.approvalStatus = 8
        }
        return finalWholeData
    }

    const submitValidCheck = (pData) => {
        switch (data.complainceControlIndex[data.complainceControlIndex.length - 1].controlId) {
            case BINARY_CONTROL_ID:
                {
                    const find = pData.binaryAnswers.find((ele) => ele.answer !== 0)
                    if (!find) {
                        return false
                    }
                }
                break
            case FORM_CONTROL_ID:
                {
                    const formsAnswers = pData?.formResponses && pData?.formResponses?.every(ele => {
                        return ele?.byWhen !== null && ele?.byWhen !== ''
                    })
                    if (!formsAnswers) {
                        return false
                    }
                    break
                }
            case CHECKLIST_CONTROL_ID:
                {
                    const find = pData?.checkListResponses.every(ele => ele.response)
                    if (!find) {
                        return false
                    }
                    break
                }
            default:
                break
        }
        return true
    }
    const handleFinalSave = () => {
        const finalWholeData = convertDataForPost()
        createUserCompliance(finalWholeData).then(() => { viewCompById() })
    }

    const handleSubmitRedirect = () => {
        navigate(routePath + '/' + '?bodyType=' + bodyType + '&matrix=' + 1 + '&status=' + 1 + '&view=' + view)
    }
    const [buttonName, setButtonName] = useState('')
    const buttonRef = useRef()
    const handleSubmitInitial = async (from) => {
        const finalWholeData = convertDataForPost()
        if (from === 'core' && !finalWholeData.binaryAnswers.find((ele) => ele.answer === 2)) {
            // if (data?.complainceControlIndex?.length - 1 < activeTab) {
            setActiveTab(activeTab + 1)
            queryParams.set('activeTab', activeTab + 1)
            navigate(`?${queryParams.toString()}`)
            // }
            // handleFinalSave()
        } else {
            if (raValidate(ACC_RACID) !== raValidate(RESP_RACID)) {
                if (buttonRef.current.textContent === 'Next' || (buttonRef.current.textContent === 'Submit' && isAccontableAvail === 1)) handleSubmitRedirect()
            }
        }
        await handleFinalSave()
        if (submittionComplete && raValidate(ACC_RACID) !== raValidate(RESP_RACID)) {
            handleSubmitRedirect()
        } else {
            if ((isAccontableAvail === 0 || raValidate(ACC_RACID)) && ((+viewTab === +data.complainceControlIndex[data.complainceControlIndex.length - 1].controlId) || finalWholeData.binaryAnswers.find((ele) => ele.answer === 2))) {
                setOpenProceed(true)
            }
        }
    }

    const getTextName = (name) => {
        return name
    }
    const handleApproveReject = (type) => {
        const finalWholeData = convertDataForPost()
        const approvalData = {
            complianceId: finalWholeData?.complianceId,
            approved: null,
            comments: null,
            approvedBy: userId,
            dueDate: new Date(finalWholeData?.dueBy),
            dueFor: new Date(finalWholeData?.dueFor)
        }
        if (type === 'approve') {
            approvalData.approved = true
            createApproveCompliance(approvalData, 'Compliance approved successfully').then(() => { viewCompById() })
        } else {
            approvalData.approved = false
            approvalData.comments = comments
            createApproveCompliance(approvalData, 'Compliance rejected successfully').then(() => { viewCompById() })
        }
        handleSubmitRedirect()
    }
    const [drawType, setDrawType] = useState('')
    const [timelineDialog, setTimelineDialog] = useState(false)
    const closeTimelineDialog = () => {
        setTimelineDialog(false)
    }
    const features = JSON.parse(localStorage.getItem('features'))
    const raValidate = (raciId) => {
        const find = data?.raciiMatrices.find((ele) => ele.raciId === raciId)
        if (find?.userId === +userId) {
            return true
        } else {
            return false
        }
    }
    const formFileRef = useRef([])
    const isAdmin = JSON.parse(localStorage.getItem('isAdmin'))
    const [commentEditState, setCommentEditState] = useState({ right: false })
    const [comments, setComments] = useState('')
    const [openProceed, setOpenProceed] = useState(false)
    const handleCloseProceed = () => {
        setOpenProceed(false)
    }
    const [isViewComments, setIsViewComments] = useState({ right: false })
    const ref = useRef()
    const toggleDrawer = () => {
        ref.current.toggleDraw()
    }
    const historyApiCall = () => {
        getComplianceTimeline(complainceId, data?.dueBy)
    }
    const lastChecklistValidaton = () => {
        const lastTab = data?.complainceControlIndex[data.complainceControlIndex.length - 1]?.controlId === 4
        const allChecklistSelect = data?.checkLIst.every(item => {
            return item.response
        })
        if (lastTab && allChecklistSelect) {
            return 'submit'
        } else if (allChecklistSelect) {
            return 'all filled'
        } else if (lastTab) {
            return 'save'
        }
        return ''
    }

    return (
        <>
            <Loading isLoading={loading || sepLoading} />

            <VerticalTimelineContainer timelineType={'Compliance'} data={complianceTimelineData} apiCall={historyApiCall} ref={ref} />

            <TimelineDialog isOpen={timelineDialog} handleClose={closeTimelineDialog} frequency={data?.complainceTimeline?.frequency || 1} timeline={data?.complainceTimeline?.timeLine || ''} period={data?.complainceTimeline?.period || 1} interCutOff={data?.complainceTimeline?.internalCutoff} />

            {<div className={cn(moreDetails ? '' : isAdmin ? 'h-full' : 'h-[92%]', 'p-5 flex flex-col')}>
                <Card className='h-full p-10  overflow-auto'>
                    <div className='min-h-[20%]'>
                        <div className='flex justify-between items-center w-50% mb-7'>
                            <div className='w-[85%] flex flex-col gap-4'>
                                <div className='pb-3 flex gap-7'>
                                    <div className='flex items-center justify-start gap-2'>
                                        <div className='text-primary text-subHeading-2 whitespace-nowrap'>{t('Compliance Title')} </div>
                                        <div className='text-b5 text-muted'>{data?.title || 'NA'}</div>
                                    </div>
                                    <div className='flex items-center justify-start gap-2'>
                                        <div className='text-primary text-subHeading-2 whitespace-nowrap'>{t('Regulation')}</div>
                                        <div className='text-b5 text-muted'>{getOrgRegulationData?.find((ele) => ele.regulationId === +data?.regulationId)?.regulation || 'NA'}</div>
                                    </div>
                                </div>
                                <div className='flex gap-7 items-center'>
                                    <div className='flex gap-3 items-center'>
                                        <div className='text-primary text-subHeading-2 whitespace-nowrap'>{t('Frequency')}</div>
                                        <div className='text-muted text-b5'>{frequencies.find(ele => ele.value === data?.complainceTimeline?.frequency)?.label || 'NA'}</div>
                                    </div>
                                    <div className='flex gap-3 items-center'>
                                        <div className='text-primary text-subHeading-2 whitespace-nowrap'>Timeline</div>
                                        <div className='text-muted text-b5'>{data
                                            ? <div className='flex justify-between gap-2 items-center'><div className='text-b5 text-muted'>{`Every ${getOrdinalSuffix(data?.complainceTimeline?.timeLine)} ${frequencies.find(ele => ele.value === data?.complainceTimeline?.frequency)?.label}`} {complianceData.timeline.find(ele => ele.period === +data?.complainceTimeline?.frequency && ele.value === data?.complainceTimeline?.period)?.label}</div>
                                                <Tooltip title="View Timeline" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                                    <div onClick={() => setTimelineDialog(true)}><img className='h-6 w-6 cursor-pointer' src='/Common/Icon/calenderIconGreen.svg' /></div></Tooltip></div>
                                            : 'NA'}</div>
                                    </div>
                                    <div className='flex gap-3 items-center'>
                                        <div className='text-primary text-subHeading-2 whitespace-nowrap'>Due for</div>
                                        <div className='text-muted text-b5'>{data
                                            ? monthConvert(data?.dueFor)
                                            : 'NA'}</div>
                                    </div>
                                    <div className='flex gap-3 items-center'>
                                        <div className='text-primary text-subHeading-2 whitespace-nowrap'>Soft Target</div>
                                        <div className='text-muted text-b5'>{data ? dateConvert(data?.cutOff) : 'NA'}</div>
                                    </div>
                                    <div className='flex gap-3 items-center'>
                                        <div className='text-primary text-subHeading-2 whitespace-nowrap'>Hard Target</div>
                                        <div className='text-muted text-b5'>{data ? dateConvert(data?.modifiedDue) : 'NA'}</div>
                                    </div>
                                    {featValid(features, UPDATE_COMPLIANCE) && isAdmin && <div className='cursor-pointer' onClick={editCompliance}>
                                        <Tooltip title="Edit Due Date" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                            <EditPencilIcon />
                                        </Tooltip>
                                    </div>}
                                </div>
                            </div>
                            <div className='w-[15%]'>
                                <div onClick={() => setMoreDetails(!moreDetails)} className='flex gap-4 whitespace-nowrap items-center cursor-pointer text-muted text-h4'>
                                    {moreDetails ? 'Less Info ' : 'More Info '}
                                    <img style={{ transform: moreDetails ? 'rotate(90deg)' : 'rotate(270deg)' }} className='h-4 w-4' src={'/Common/Icon/minimizer.svg'} />
                                </div>
                            </div>
                        </div>
                        <div className='w-full' style={{ border: '0.5px solid hsl(var(--primary-table-head))' }}></div>
                        {moreDetails && <div className='50% mt-7 mb-8'>
                            <div className={cn('dropdown-section flex justify-between gap-10')}>
                                <div className='general-section  w-[50%]'>
                                    <div className='text-primary p-3 text-subHeading-2 font-[700] rounded-md bg-[hsl(var(--primary-table-head))] w-[100%] flex items-center gap-2'> General</div>
                                    <div className='p-4'>
                                        <div className='flex justify-between min-h-[54px]'>
                                            <div className='text-primary font-[500] text-subHeading-2'>{t('Description')}</div>
                                            <div className='text-b5 text-muted w-2/4 min-w-[50%]'>{data?.description}</div>
                                        </div>
                                        <div className='flex justify-between min-h-[54px]'>
                                            <div className='text-primary font-[500] text-subHeading-2'>{t('Category')}</div>
                                            <div className='text-b5 text-muted w-2/4 min-w-[50%]'>{t('Regulatory')}</div>
                                        </div>
                                        {/* <div className='flex justify-between py-2'>
                                        <div className='text-primary font-[500] text-subHeading-2'>{t('Department')}</div>
                                        <div className='text-muted text-b5 w-2/4 min-w-[50%]'>{data?.deparments?.map((ele, i) => `${ele?.name}${i !== data?.deparments?.length - 1 ? ', ' : ''}`)}</div>
                                    </div> */}
                                        <div className='flex justify-between min-h-[54px]'>
                                            <div className='text-primary font-[500] text-subHeading-2'>{t('Compliance for')}</div>
                                            <div className='text-b5 text-muted w-2/4 min-w-[50%]'>{dataFind(compForOptions, data?.complainceFor)}</div>
                                        </div>
                                        <div className='flex justify-between min-h-[54px]'>
                                            <div className='text-primary font-[500] text-subHeading-2'>{t('Compliance category')}</div>
                                            <div className='text-b5 text-muted w-2/4 min-w-[50%]'>{dataFind(compCategoryOptions, data?.complainceCategory)}</div>
                                        </div>
                                        <div className='flex justify-between min-h-[54px]'>
                                            <div className='text-primary font-[500] text-subHeading-2'>{t('Sub category')}</div>
                                            <div className='text-b5 text-muted w-2/4 min-w-[50%]'>{dataFind(compSubCategoryOptions, data?.subCategory)}</div>
                                        </div>
                                        <div className='flex justify-between min-h-[54px]'>
                                            <div className='text-primary font-[500] text-subHeading-2'>{t('Status')}</div>
                                            <div className='text-b5 text-muted w-2/4 min-w-[50%]'>{data?.status === 1 ? 'Active' : 'In Active'}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className='general-section  w-[50%]'>
                                    <div className='text-primary text-subHeading-2 font-[700] p-3 rounded-md bg-[hsl(var(--primary-table-head))] w-[100%] flex items-center gap-2'>{t('RACI Matrix')} </div>
                                    <div className='p-4'>
                                        {
                                            Object.keys(raci).map((item, i) => {
                                                const raciData = data.raciiMatrices.find((element) => element.raciId === i + 1)
                                                return (
                                                    <div key={i} className='flex justify-between py-2'>
                                                        <div className='text-primary font-[500] text-subHeading-2'>{item}</div>
                                                        <div className='min-w-[60%]'>
                                                            {!raciData?.user && !raciData?.role && <div className='text-muted'>-</div>}
                                                            {!raciData?.user && raciData?.role && <div className='flex gap-1 text-b5 text-muted'><img src='/Common/Icon/DangerIcon.svg' />Vacant</div>}
                                                            {raciData?.user && <div className='text-b5 text-muted'>{raciData?.user}</div>}
                                                            <div style={{ color: roleColor(raciData?.role) }} className={cn('!text-b4 regulation-cell-second')}>{raciData?.role} </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='w-full' style={{ border: '0.5px solid hsl(var(--primary-table-head))' }}></div>
                            {/* <div className='data-setup-section mt-7 mb-1'>
                            <div className='text-primary p-3 text-subHeading-2 font-700] rounded-md bg-[hsl(var(--primary-table-head))] w-[100%] flex items-center gap-2'> {t('Data Setup')}</div>
                            <div className='flex items-center justify-between gap-1 p-5'>
                                <div className='flex justify-between gap-1 items-center'>
                                    <div className='text-primary text-subHeading-2'>{'Action'}</div>
                                    <div className='text-b5 text-muted'>{data?.complainceTimeline?.action === 1 ? 'Manual' : 'Predefined'}</div>
                                </div>
                                <div className='flex justify-between gap-1 items-center'>
                                    <div className='text-primary text-subHeading-2'>{t('Frequency')}</div>
                                    <div className='text-b5 text-muted'>{frequencies.find(ele => ele.value === data?.complainceTimeline?.frequency)?.label}</div>
                                </div>
                                <div className='flex justify-between gap-2 items-center'>
                                    <div className='text-primary text-subHeading-2'>{t('Timeline')}</div>
                                    <div className='text-b5 text-muted'>{data?.complainceTimeline?.timeLine} {complianceData.timeline.find(ele => ele.period === +data?.complainceTimeline?.frequency && ele.value === data?.complainceTimeline?.period)?.label}</div>
                                    <div onClick={() => setTimelineDialog(true)}><img className='h-4 w-4' src='/Common/Icon/calenderIconGreen.svg' /></div>
                                </div>
                                <div className='flex justify-between gap-3 items-center'>
                                    <div ><img className='h-5 w-5' src='/Common/Icon/warningIcon.svg' /></div>
                                    <div className='text-primary text-subHeading-2'>{t('Internal Cut Off')}</div>
                                    <div className='text-b5 text-muted'>{data?.complainceTimeline?.internalCutoff} Days before the deadline</div>
                                </div>
                            </div>
                        </div> */}
                            <div className='w-full' style={{ border: '0.5px solid hsl(var(--primary-table-head))' }}></div>
                        </div>}
                    </div>
                    <div className='h-[10%] flex justify-between items-center'>
                        <Tabs value={activeTab}
                            onValueChange={onTabValueChange}
                            className='h-[5%]'
                        // style={{ marginTop: '60px' }}
                        >
                            <TabsList>
                                {(data?.approvalStatus === STATUS_ENUMS.Pending || data?.approvalStatus === STATUS_ENUMS.Rejected || data?.approvalStatus === STATUS_ENUMS.Approved || data?.approvalStatus === STATUS_ENUMS.Closed || (raValidate(ACC_RACID) && data?.binaryQuestions?.find(ele => +ele.answer !== 2)) || isAdmin) && <img onClick={() => handleTab('dec')} className={cn(viewTab === +data?.complainceControlIndex?.[0]?.controlId ? 'bg-popover pointer-events-none opacity-50' : '', 'rotate-180 cursor-pointer', 'h-[22px] w-[22px]')} src='/Common/Icon/tabrightmoveicon.svg' />
                                }
                                {data?.complainceControlIndex?.map((ele, i) => {
                                    return (
                                        <TabsTrigger style={{ margin: '0 9px' }} className={cn(+activeTab < ele.index ? 'text-grey pointer-events-none' : '', '!text-menu')} key={i} value={ele.index}>{controls?.find((item) => +item.controlId === +ele.controlId)?.controlName}</TabsTrigger>
                                    )
                                })}
                                {(data?.approvalStatus === STATUS_ENUMS.Pending || data?.approvalStatus === STATUS_ENUMS.Rejected || data?.approvalStatus === STATUS_ENUMS.Approved || data?.approvalStatus === STATUS_ENUMS.Closed || (raValidate(ACC_RACID) && data?.binaryQuestions?.find(ele => +ele.answer !== 2)) || isAdmin) && <img onClick={() => handleTab('inc')} className={cn(+viewTab === +data?.complainceControlIndex?.[data?.complainceControlIndex?.length - 1]?.controlId ? 'bg-popover pointer-events-none opacity-50' : '', 'cursor-pointer h-[22px] w-[22px]')} src='/Common/Icon/tabrightmoveicon.svg' />
                                }
                            </TabsList>
                        </Tabs>
                        <Card>
                            <div className='flex justify-between px-5 py-3'>
                                <Tooltip title="Timeline" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>

                                    <div className='cursor-pointer active:scale-90 transition-transform duration-150' onClick={() => toggleDrawer()}><img className='w-8' src='/Assets/chatTimeline.svg' /></div>
                                </Tooltip>
                                {/* periodicity currently not implemented */}
                                {/* <div className='h-[25px] w-[1.5px] bg-[hsl(var(--primary-table-head))]'></div>
                            <img className='w-9' src='/Assets/analysis.svg' onClick={() => toggleDrawer()} /> */}
                            </div>
                        </Card>
                    </div>
                    <div className={cn((data?.approvalStatus === null || data?.approvalStatus === 10) ? '' : '', isAdmin && 'pointer-events-none', 'flex-grow h-[60%] mt-[10px]')}>
                        {
                            data?.complainceControlIndex?.map((item, i) => {
                                return (
                                    <>
                                        {item.controlId === 1 &&
                                            <UserBinaryQuestionTable arr={binaryArray} setArr={setBinaryArray} setSubmitValid={setSubmitValid} setSubmissionComplete={setSubmissionComplete} activeTab={viewTab} controls={controls} control={control} errors={errors} data={data?.binaryQuestions} />

                                        }
                                        {item.controlId === 2 &&
                                            <>
                                                <UserFormsQuestionTable editAccess={data?.approvalStatus === STATUS_ENUMS.Closed || data?.approvalStatus === STATUS_ENUMS.Pending || (data?.approvalStatus === STATUS_ENUMS.Rejected && raValidate(ACC_RACID))} surveyValidate={surveyValidate} setEditData={setEditData} setDrawType={setDrawType} editState={editState} setEditState={setEditState} activeTab={viewTab} controls={controls} control={control} errors={errors} data={data?.forms} formFileRef={formFileRef} />

                                            </>
                                        }
                                        {item.controlId === 3 &&
                                            <UserThresholdLimitQuestions surveyValidate={surveyValidate} setEditData={setEditData} setDrawType={setDrawType} editState={editState} setEditState={setEditState} activeTab={viewTab} controls={controls} control={control} errors={errors} data={data?.thresholdLimits} />
                                        }
                                        {item.controlId === 4 &&
                                            <UserChecklistQuestions dueBy={data?.modifiedDue} editAccess={data?.approvalStatus === STATUS_ENUMS.Closed || data?.approvalStatus === STATUS_ENUMS.Pending || (data?.approvalStatus === STATUS_ENUMS.Rejected && raValidate(ACC_RACID))} setSubmitValid={setSubmitValid} setdata={setdata} activeTab={viewTab} controls={controls} control={control} errors={errors} data={data?.checkLIst} />
                                        }
                                    </>
                                )
                            })
                        }
                        <ComplianceDrawer viewCompById={viewCompById} apiCall={apiCall} setEditData={setEditData} surveyValidate={surveyValidate} wholeData={data} editData={editData} setEditState={setEditState} drawType={drawType} editState={editState} />
                    </div>
                </Card>
            </div>}

            {!isAdmin && <div className="flex justify-end items-center space-x-4 h-[8%] pr-4 border-t-[hsl(var(--primary-foreground))]">
                {data?.rejectedComments?.length > 0 && (data.approvalStatus === STATUS_ENUMS.Rejected || data.approvalStatus === STATUS_ENUMS.Initial) && raValidate(RESP_RACID) && <div className='text-primary underline  cursor-pointer' onClick={() => setIsViewComments({ right: true })}>View Comments</div>}

                {activeTab > 0 && !isAdmin && raValidate(RESP_RACID) && data?.approvalStatus !== STATUS_ENUMS.Pending && data?.approvalStatus !== STATUS_ENUMS.Closed && <Button variant='outline'
                    style={{ color: 'hsl(var(--primary))', borderColor: 'hsl(var(--primary))' }} onClick={() => handleTab('dec')}>
                    Back
                </Button>}
                {/* && featValid(features, UPDATE_COMPLIANCE) */}
                {data?.approvalStatus !== STATUS_ENUMS.Pending && data?.approvalStatus !== STATUS_ENUMS.Closed && data?.approvalStatus !== STATUS_ENUMS.Approved && !isAdmin && raValidate(RESP_RACID)
                    ? <Button ref={buttonRef} className={cn((submitValid || (atleastChecklist && viewTab === CHECKLIST_CONTROL_ID)) ? '' : '!bg-[#e5e5e5] !text-grey !shadow-none pointer-events-none ')}
                        readOnly={submitValid} onClick={() => handleSubmitInitial(data?.complainceControlIndex.length - 1 === +activeTab ? 'save' : 'core')}>
                        {/* {data?.complainceControlIndex.length - 1 === +activeTab || submittionComplete ? (lastChecklistValidaton() === 'save' ? 'Save' : 'Submit') : 'Next'} */}
                        {data?.complainceControlIndex.length - 1 === +activeTab ? (submitValid ? getTextName('Submit') : getTextName('Save')) : (lastChecklistValidaton('all filled') || data.complainceControlIndex[activeTab].controlId === 2 ? getTextName('Next') : getTextName('Save'))}
                    </Button>
                    : null}
                {
                    (raValidate(ACC_RACID)) && (raValidate(ACC_RACID) !== raValidate(RESP_RACID)) && data?.approvalStatus === STATUS_ENUMS.Pending && data?.approvalStatus !== STATUS_ENUMS.Closed && <>
                        {/* className={cn(data?.approvalStatus !== 3 ? '' : '!bg-[#e5e5e5] !text-grey !shadow-none pointer-events-none ')}  */}
                        <Button variant='outline' style={{ color: 'hsl(var(--Extreme))', borderColor: 'hsl(var(--Extreme))' }} onClick={() => setCommentEditState({ right: true })}>Reject</Button>
                        <Button readOnly={submitValid} onClick={() => handleApproveReject('approve')}>Approve</Button>
                    </>
                }
            </div>}
            <ComplianceCommentsDrawer handleReject={() => handleApproveReject('reject')} setEditState={setCommentEditState} editState={commentEditState} comments={comments} setComments={setComments} />
            <ApproveDialog isOpened={openProceed} handleCloseModal={handleCloseProceed} handleProceed={handleApproveReject} />
            <ViewRejectComments
                isViewComments={isViewComments}
                setIsViewComments={setIsViewComments}
                comments={data?.rejectedComments}
            />
        </>
    )
}

export default ViewComplianceUser
